// Status -> chip class. Unknown statuses fall back to the neutral 'Planned'
// style (never an error style). Session 8 (B4): 'Publishing…' (v_portal_plan)
// and 'publishing' (v_portal_posts) share the in-progress family; 'Waiting on
// client' (agency wording in v_portal_plan) is neutral, not the warning style.
const CLASS_MAP = {
  'Published':            'chip-Published',
  'Ready':                'chip-Ready',
  'Ready to post':        'chip-Ready',
  'Awaiting your input':  'chip-Awaiting',
  'Waiting on client':    'chip-Waiting',
  'In progress':          'chip-InProgress',
  'Publishing…':          'chip-InProgress',
  'publishing':           'chip-InProgress',
  'Planned':              'chip-Planned',
};

const LABEL_MAP = {
  'publishing': 'Publishing…',
};

export default function StatusChip({ status }) {
  const cls = CLASS_MAP[status] || 'chip-Planned';
  return <span className={`chip ${cls}`}>{LABEL_MAP[status] || status}</span>;
}
